import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { CenterFocusIcon } from '@hugeicons/core-free-icons'

const FitRegionButton = ({ item, uiStore, t }) => (
  <button onClick={e => {
    e.currentTarget.blur()
    uiStore.setBoundsToItem(item)
  }}
  >
    <HugeiconsIcon icon={CenterFocusIcon} size={18} className='popup-menu__icon' />
    <span>{t('GLOBAL.FIT_REGION')}</span>
  </button>
)

export default withTranslation()(inject('uiStore')(observer(FitRegionButton)))
